import { ServiceProjectStatusResponseServiceProjectStatusEnum } from 'types/entity/service-project-status-response';

const isStatsInList = (
  list: ServiceProjectStatusResponseServiceProjectStatusEnum[],
  status: ServiceProjectStatusResponseServiceProjectStatusEnum,
): boolean => list.includes(status);

export const isOpenOrFrozen = (
  status: ServiceProjectStatusResponseServiceProjectStatusEnum,
): boolean => isStatsInList(
  [ServiceProjectStatusResponseServiceProjectStatusEnum.Open, ServiceProjectStatusResponseServiceProjectStatusEnum.Frozen],
  status,
);

export const isOpenOrFrozenOrClosed = (
  status: ServiceProjectStatusResponseServiceProjectStatusEnum,
): boolean => isStatsInList(
  [ServiceProjectStatusResponseServiceProjectStatusEnum.Open, ServiceProjectStatusResponseServiceProjectStatusEnum.Frozen, ServiceProjectStatusResponseServiceProjectStatusEnum.Closed],
  status,
);
